import { Button, Collapse, CollapseProps, Form } from "antd";
import { Link } from "react-router-dom";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import AboutOrganization from "../../../components/Admin/Organization/AboutOrganization";
import AddressOrganization from "../../../components/Admin/Organization/AddressOrganization";
import IdentityOrganization from "../../../components/Admin/Organization/IdentityOrganization";
import PaymentOrganization from "../../../components/Admin/Organization/PaymentOrganization";
import TitleBar from "../../../components/common/TitleBar";
import colors from "../../../constants/colors";
import SidebarLayout from "../../../layouts/SidebarLayout";

const backLink = "/admin/organizations/list";

export default function ManageOrganization() {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {
    // console.log(values);
  };

  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "About Organization",
      children: <AboutOrganization form={form} />,
    },
    {
      key: "2",
      label: "Address",
      children: <AddressOrganization form={form} />,
    },
    {
      key: "3",
      label: "Payment Details",
      children: <PaymentOrganization form={form} />,
    },
    {
      key: "4",
      label: "Identity",
      children: <IdentityOrganization form={form} />,
    },
  ];

  return (
    <SidebarLayout title="Organizations">
      <TitleBar title="New Organization" backLink={backLink} />

      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="max-w-[700px] mx-auto">
          <Collapse
            rootClassName="organization-collapse"
            className="border-transparent bg-transparent"
            items={items}
            defaultActiveKey={["1", "2", "3", "4"]}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <span
                className={`transition-all ${isActive ? "rotate-180" : ""}`}
              >
                <SelectDropdownLgIcon color={colors.bodyText} />
              </span>
            )}
          />

          <div className="flex justify-between">
            <Link to={backLink}>
              <Button className="normal-dark-button modal-button" size="middle">
                Cancel
              </Button>
            </Link>

            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              // loading={isLoading}
            >
              Add Organization
            </Button>
          </div>
        </div>
      </Form>
    </SidebarLayout>
  );
}
